import React, { Component } from 'react';
import { translate } from '../../base/i18n/functions';
import Spinner from '../../base/ui/components/web/Spinner';
import DesktopSourcePreview from './DesktopSourcePreview';
/**
 * React component for showing a grid of DesktopSourcePreviews.
 *
 * @augments Component
 */
class DesktopPickerPane extends Component {
    /**
     * Initializes a new DesktopPickerPane instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props) {
        super(props);
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { onClick, onDoubleClick, selectedSourceId, sources, t } = this.props;
        const classNames = `desktop-picker-pane default-scrollbar source-type-all-windows invisible-scrollbar`;
        const previews = Array.isArray(sources) && sources.length > 0
            ? sources.map(source => (React.createElement(DesktopSourcePreview, { key: source.id, onClick: onClick, onDoubleClick: onDoubleClick, selected: source.id === selectedSourceId, source: source })))
            : (React.createElement("div", { className: 'desktop-picker-pane-spinner' },
                React.createElement(Spinner, null)));
        return (React.createElement("div", { className: classNames }, previews));
    }
}
export default translate(DesktopPickerPane);
